const isArrayNotEmpty = (value: Array<any>) =>
  Array.isArray(value) && value.length > 0;

export default isArrayNotEmpty;



// WEBPACK FOOTER //
// ./src/services/financigservice/utils/isArrayNotEmpty.ts